import React, { PureComponent } from 'react';
import styled, { withTheme } from "styled-components";
import Moment from 'moment';
import H2 from "./H2";
import { valueOrDefault } from "@tomeravni/easybizy-js-common/common";

const Wrapped = styled(H2)`
  display: flex;
  align-items: center;
  font-weight: 500;
  margin: 0;
  padding: 0;
  direction: ltr;
`

class TimerCounter extends PureComponent {
	state = { minutes: '00', seconds: '00', didSet: false }

	componentDidMount() {
		if (this.props.destinationTime) {
			this.handleDestinationSet(this.props.destinationTime);
		}
	}

	/**
	 * Only a new destination restarts the countdown. This runs on every parent render, and restarting
	 * on each one re-fired onTimeUp once the destination had passed - the payment page then cancelled
	 * its session in a loop, with a token the first cancel had already cleared (DELETE /sessions/null).
	 */
	componentWillReceiveProps(nextProps, nextContext) {
		const next = nextProps.destinationTime;
		const previous = this.props.destinationTime;
		const changed = next ? !previous || !Moment(next).isSame(previous) : !!previous;
		if (changed) {
			this.handleDestinationSet(next);
		}
	}

	handleDestinationSet = (destinationTime) => {
		if (this.timer) {
			clearInterval(this.timer);
		}
		this.didFireTimeUp = false;

		if (destinationTime) {
			this.setState({
				destinationTime: Moment(destinationTime).add(-1 * valueOrDefault(this.props.decreaseSeconds, 0), 'seconds'),
				didSet: true
			}, this.updateTime);
			this.timer = setInterval(() => {
				this.updateTime();
			}, 1000);
		} else {
			this.setState({ destinationTime: null, minutes: '00', seconds: '00' });
		}
	}

	updateTime = () => {
		let destinationTime = this.state.destinationTime;
		if (!destinationTime) {
			return this.handleDestinationSet();
		}


		let diffMinutes = Math.max(destinationTime.diff(Moment(), 'minutes'), 0);
		const minutes = diffMinutes.toString().padStart(2, '0');
		let diffSeconds = Math.max(destinationTime.diff(Moment(), 'seconds'), 0);
		const seconds = (diffSeconds - diffMinutes * 60).toString().padStart(2, '0');
		this.setState({ minutes, seconds });

		if (diffMinutes === 0 && diffSeconds === 0 && !this.didFireTimeUp) {
			this.didFireTimeUp = true;
			clearInterval(this.timer);
			this.timer = null;
			this.timer = setTimeout(() => {
				if (this.props.onTimeUp) {
					this.props.onTimeUp();
				}
			}, valueOrDefault(this.props.decreaseSeconds, 0) * 1000);
		}
	}

	componentWillUnmount() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}

	render() {
		return (
			<Wrapped>
				{ this.state.didSet && (<span>{ this.state.minutes }:{ this.state.seconds }</span>) }
			</Wrapped>
		)
	}
}

export default withTheme(TimerCounter);
